module.exports = __webpack_public_path__ + "static/banner_vote-91f904608670827e03236ecd94b291f4.png";